export default "__VITE_ASSET__BisA1CN8__"